"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Countdown", {
  enumerable: true,
  get: function get() {
    return _countdown.default;
  }
});
exports.SECONDS = exports.MINUTES = exports.HOURS = exports.DAYS = void 0;
Object.defineProperty(exports, "TimeProvider", {
  enumerable: true,
  get: function get() {
    return _timeProvider.default;
  }
});
Object.defineProperty(exports, "Timed", {
  enumerable: true,
  get: function get() {
    return _timed.default;
  }
});
Object.defineProperty(exports, "connectTime", {
  enumerable: true,
  get: function get() {
    return _connectTime.connectTime;
  }
});
Object.defineProperty(exports, "useCountdown", {
  enumerable: true,
  get: function get() {
    return _useCountdown.useCountdown;
  }
});
Object.defineProperty(exports, "useTime", {
  enumerable: true,
  get: function get() {
    return _useTime.useTime;
  }
});

var _timeSync = _interopRequireDefault(require("time-sync"));

var _connectTime = require("./connect-time");

var _timeProvider = _interopRequireDefault(require("./time-provider"));

var _timed = _interopRequireDefault(require("./timed"));

var _countdown = _interopRequireDefault(require("./countdown"));

var _useTime = require("./use-time");

var _useCountdown = require("./use-countdown");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SECONDS = _timeSync.default.SECONDS,
    MINUTES = _timeSync.default.MINUTES,
    HOURS = _timeSync.default.HOURS,
    DAYS = _timeSync.default.DAYS;
exports.DAYS = DAYS;
exports.HOURS = HOURS;
exports.MINUTES = MINUTES;
exports.SECONDS = SECONDS;